module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "fmh"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB6"
    }
  }, [_vm._v("General preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB7"
    }
  }, [_vm._v("Author’s preface")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB8"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB9"
    }
  }, [_vm._v("Select bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB10"
    }
  }, [_c('strong', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB10#rch1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "nl3"
  }), _vm._v("Hermeneutical considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB10#rch2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "nl3"
  }), _vm._v("Historical matters")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB10#rch3"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "nl3"
  }), _vm._v("Literary matters")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/9781789742671_EPUB10#rch4"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "nl3"
  }), _vm._v("Theological messages and themes")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('span', {
    attrs: {
      "href": "#/9781789742671_EPUB11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "bold1"
  }, [_vm._v("Analysis")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    staticClass: "nl5"
  }), _c('span', {
    attrs: {
      "href": "#/9781789742671_EPUB13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "bold1"
  }, [_vm._v("Commentary")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOTC_praise",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for the Tyndale Commentaries")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/appen9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the author")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOTC_commentaries",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tyndale Commentaries from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "contents",
    attrs: {
      "id": "ch16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/IVPtbs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f962ca10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781789742671_EPUB5.vue
// module id = 66
// module chunks = 0